<template>
    <div class="spinner">
        <div class="background"></div>
        <div class="marker"></div>
        <div class="central-content">
            <VJoyIcon class="ai-color-gradient" name="sparkles" size="xsmall" />
        </div>
    </div>
</template>
<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';
</script>
<style scoped lang="scss">
    @property --opacity {
        syntax: '<percentage>';
        initial-value: 100%;
        inherits: false;
    }

    .spinner {
        --size: 75px;
        --line-size: 10px;
        --border-color: #fff5f5;
        --center-shadow-color: #333;
        --animate-duration: 5s;

        position: relative;
        width: var(--size);
        height: var(--size);

        > div {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            border: 1px solid var(--joy-color-neutral-0);
            border-radius: 100%;
        }

        .marker {
            width: var(--size);
            height: var(--size);
            background: conic-gradient(transparent var(--opacity), var(--border-color) 0% 60%);
            animation: conic-gradient var(--animate-duration) ease infinite;
        }

        .central-content {
            background-color: var(--joy-color-background-default);
            width: calc(var(--size) - var(--line-size));
            height: calc(var(--size) - var(--line-size));
            box-shadow: 0px 0px 2px var(--center-shadow-color);
            justify-content: center;
            align-items: center;
            display: flex;
        }

        .background {
            width: var(--size);
            height: var(--size);
            background: rgb(144, 53, 160);
            background: linear-gradient(90deg, rgba(144, 53, 160, 1) 0%, rgba(252, 87, 87, 0.85) 100%);
        }

        @keyframes conic-gradient {
            0% {
                --opacity: 0%;
            }

            100% {
                --opacity: 100%;
            }
        }
    }

    .ai-color-gradient {
        background: linear-gradient(to left, rgba(252, 87, 87, 0.8509803922), var(--joy-color-ai-primary-30));
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
    }
</style>
